import React, { useMemo, useState } from "react";
import useAsyncEffect from "use-async-effect";
import { askAPI, RequestMethod } from "../../api/api";
import { SmallCard } from "../../Card/SmallCard";
import { Hexagen } from "../../types";
import Balatro from "../../utils/Balatro";
import { CardContainerProps } from "./types";

export const CardContainer = React.memo(
  ({
    hexagenUid,
    highlighted,
    withZoom = true,
    disableAppearAnimation = false,
  }: CardContainerProps) => {
    const highlightedContent = useMemo(() => {
      if (!highlighted) return null;
      return (
        <div className="w-full h-full bg-black border-4 border-black absolute top-0 left-0 cursor-pointer">
          <Balatro
            color1="#2277ee"
            color2="#2233ee"
            color3="#000000"
            spinSpeed={10}
          />
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <span
              className="text-black text-8xl font-bold"
              style={{
                textShadow:
                  "0 0 20px #0000ff, 0 0 40px #0000ff, 0 0 60px #0000ff",
              }}
            >
              ?
            </span>
          </div>
        </div>
      );
    }, [highlighted]);

    const [card, setCard] = useState<Hexagen | null>(null);
    const [isAnimating, setIsAnimating] = useState(false);

    useAsyncEffect(async () => {
      if (!hexagenUid) return;
      const card = await askAPI<Hexagen>(
        `/api/hexagen/info-by-uid?uid=${hexagenUid}`,
        RequestMethod.GET
      );
      if (card) {
        setCard(card);
        if (!disableAppearAnimation) {
          setIsAnimating(true);
          setTimeout(() => setIsAnimating(false), 400);
        }
      }
    }, [hexagenUid, disableAppearAnimation]);

    const cardContent = useMemo(() => {
      if (!card) return null;
      return (
        <div
          className={`w-full h-full border-4 border-black absolute top-0 left-0 ${
            isAnimating ? "animate-card-drop" : ""
          }`}
          style={{
            boxShadow: isAnimating ? "0 20px 40px rgba(0, 0, 0, 0.3)" : "none",
            transition: "box-shadow 0.3s ease-out",
          }}
        >
          <SmallCard hexagenInfo={card} withZoom={withZoom} />
        </div>
      );
    }, [card, isAnimating, withZoom]);

    if (highlighted) return highlightedContent;
    return cardContent;
  }
);
